export default __webpack_public_path__ + "static/media/Maven.b768d677.jpg";